import React from 'react';
import clsx from 'clsx';
import { Link } from 'react-router';
import { cn } from '../../lib/helpers';
import { LectureCategory } from '../../lib/types.ts';
import { IconLock } from '../Icon.tsx';

interface SubCategoryCardProps {
    lectureCategory: LectureCategory;
    showBadge: boolean;
    children?: React.ReactNode;
}

export const ColorVariants = {
    blue: {
        bar: 'bg-blue-500',
        card: 'from-blue-100 to-blue-100/50',
    },
    green: {
        bar: 'bg-green-500',
        card: 'from-green-100 to-green-100/50',
    },
    orange: {
        bar: 'bg-orange-500',
        card: 'from-orange-100 to-orange-100/50',
    },
    red: {
        bar: 'bg-red-500',
        card: 'from-red-100 to-red-100/50',
    },
    turquoise: {
        bar: 'bg-turquoise-500',
        card: 'from-turquoise-100 to-turquoise-100/50',
    },
    purple: {
        bar: 'bg-purple-500',
        card: 'from-purple-100 to-purple-100/50',
    },
    rose: {
        bar: 'bg-rose-500',
        card: 'from-rose-100 to-rose-100/50',
    },
};

export default function SubCategoryCard({
    lectureCategory: {
        name,
        slug,
        color,
        poster,
        description,
        is_locked: isLocked,
        parent,
    },
    showBadge,
    children,
}: SubCategoryCardProps) {
    return (
        <div>
            <Link to={isLocked ? '#' : `/cviceni/lekce/${slug}`}>
                <div
                    className={cn(
                        'relative rounded-3xl bg-white shadow-sm transition-shadow',
                        !isLocked && 'hover:shadow-md',
                        isLocked && 'cursor-not-allowed'
                    )}
                >
                    {/* badge */}
                    {showBadge && (
                        <div
                            className={clsx(
                                'absolute right-0 top-0 rounded-bl-2xl rounded-tr-2xl px-4 py-1 text-sm text-white',
                                ColorVariants[color].bar
                            )}
                        >
                            {parent.name}
                        </div>
                    )}

                    {/* vertical line */}
                    <div
                        className={clsx(
                            'absolute left-0 top-[15%] h-[70%] w-1 flex-shrink-0 self-center rounded-r-md',
                            ColorVariants[color].bar
                        )}
                    />

                    {/* card body */}
                    <div
                        className={clsx(
                            'grid grid-cols-[7.25rem_2fr] items-center gap-6 rounded-3xl p-6',
                            'bg-gradient-to-r',
                            ColorVariants[color].card
                        )}
                    >
                        <div className="relative flex h-28 max-w-28 self-center">
                            {/*{isLocked && (*/}
                            {/*    <IconLock size={24} className="text-ink-700" />*/}
                            {/*)}*/}

                            {poster ? (
                                <img
                                    src={poster}
                                    className="h-full w-full rounded-xl object-contain object-center"
                                />
                            ) : (
                                <div className="h-full w-full rounded-xl bg-black/10" />
                            )}

                            {isLocked ? (
                                <div className="absolute inset-0 z-30 flex h-full w-full flex-col items-center justify-center rounded-2xl bg-black/50 backdrop-blur-sm">
                                    <IconLock
                                        size={64}
                                        className="text-cloud-100"
                                    />
                                </div>
                            ) : null}

                            {children}
                        </div>
                        <div>
                            <h4 className="">{name}</h4>
                            <p className="line-clamp-2 font-normal text-ink-800">
                                {description}
                            </p>
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    );
}
